import React, {createContext, useEffect, useState} from 'react';
import { Outlet } from 'react-router-dom';
import useUser, {PrivateUser, PrivateUserDefault} from "../hooks/useUser";

interface UserContextInterface {
    User: PrivateUser
    UserAuth: boolean,
    MutateUser: () => void
}
export const UserContext = createContext<UserContextInterface>({
    User: PrivateUserDefault,
    UserAuth: false,
    MutateUser: () => {}
})

function Rootlayout() {
    //device check
    const userAgent = navigator.userAgent;
    if (userAgent.match(/Android/i)) {
        document.body.setAttribute('data-device-type', 'Android')
    } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
        document.body.setAttribute('data-device-type', 'IOS')
    } else {
        document.body.setAttribute('data-device-type', 'PC-Desktop')
    }
    let vh = 0;

    // ** window focus/blur event
    let browserVisibleState: boolean = true;
    let list: any[] = []

    function onFocusHandler(){
        list.some((id, key)=> clearInterval(id))
        list = []
        // console.log(browserVisibleState)
        if(!browserVisibleState){
            window.location.reload()
        }
    }
    function onBlurHandler(){
        const intervalId: NodeJS.Timeout = setTimeout(()=> {
            // window.location.reload();
            browserVisibleState = false
        }, 1000 * 60 * 60) // 1시간
        list[0] = (intervalId)
    }    
    useEffect(()=> {
        if(document.hasFocus()){
            onFocusHandler()
        }else{
            onBlurHandler()
        }
    }, [])
    useEffect(() => {
        window.addEventListener('blur', onBlurHandler)
        window.addEventListener('focus', onFocusHandler)

        return () => { 
            window.removeEventListener('blur', onBlurHandler)
            window.removeEventListener('focus', onFocusHandler)
        }
    }, []);
    // ** //

    useEffect(() => {
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, []);

    const {user, mutateUser} = useUser()

    const [User, setUser] = useState<PrivateUser>(user as PrivateUser)
    const [UserAuth, setUserAuth] = useState<boolean>(false)
    function MutateUser(){
        mutateUser()
    }
    useEffect(()=> {
        setUser(user as PrivateUser)
        setUserAuth(user?.is_authenticated || false)
    }, [user])
    return (
        <UserContext.Provider value={{ User, UserAuth, MutateUser }}>
            <Outlet/>
        </UserContext.Provider>
    );
}

export default Rootlayout;